import { ThemeEvents } from '@theme/events';
import { Component } from '@theme/component';

/**
 * A custom element that displays availability + delivery time for the
 * selected variant. Listens for variant update events so it never shows a
 * stale availability status after a variant switch.
 */
class ProductAvailabilityDelivery extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateAvailability);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateAvailability);
  }

  updateAvailability = (event) => {
    if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newElement = event.detail.data.html.querySelector(
      `product-availability-delivery[data-block-id="${this.dataset.blockId}"]`
    );
    if (!newElement) return;

    this.replaceWith(newElement);
  };
}

if (!customElements.get('product-availability-delivery')) {
  customElements.define('product-availability-delivery', ProductAvailabilityDelivery);
}
